<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="relative pt-1 custome-progress">
      <div class="overflow-hidden h-1 mb-4 text-xs flex rounded bg-green-200">
        <div
          class="
            w-3/4
            shadow-none
            flex flex-col
            text-center
            whitespace-nowrap
            text-white
            justify-center
            bg-green-500
          "
        ></div>
      </div>
    </div>

    <div class="sign_confirm_block">
      <div class="body_inner">
        <div
          class="
            w-full
            flex
            items-start
            justify-start
            text-sm
            font-medium
            otpmsg-block
            mt-4
            mb-4
          "
          @click="$router.push({ name: 'confirmCell' })"
        >
          <span class="icon mr-2">
            <svg
              width="19"
              height="17"
              viewBox="0 0 19 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.7355 0.493475C7.54072 0.499152 7.35579 0.580407 7.21987 0.720038L0.219872 7.72004C0.0792729 7.8607 0.000289917 8.05143 0.000289917 8.25031C0.000289917 8.44919 0.0792729 8.63993 0.219872 8.78059L7.21987 15.7806C7.28898 15.8526 7.37176 15.91 7.46335 15.9496C7.55495 15.9892 7.65352 16.0101 7.7533 16.0111C7.85308 16.0121 7.95206 15.9932 8.04444 15.9555C8.13683 15.9178 8.22075 15.862 8.29131 15.7915C8.36187 15.7209 8.41764 15.637 8.45536 15.5446C8.49307 15.4522 8.51198 15.3533 8.51097 15.2535C8.50995 15.1537 8.48904 15.0551 8.44945 14.9635C8.40986 14.8719 8.3524 14.7891 8.28042 14.72L2.56069 9.00031H17.2501C17.3495 9.00172 17.4482 8.98336 17.5404 8.9463C17.6327 8.90924 17.7166 8.85421 17.7874 8.78443C17.8581 8.71465 17.9144 8.63149 17.9527 8.5398C17.9911 8.44811 18.0108 8.34971 18.0108 8.25031C18.0108 8.15092 17.9911 8.05252 17.9527 7.96082C17.9144 7.86913 17.8581 7.78598 17.7874 7.71619C17.7166 7.64641 17.6327 7.59139 17.5404 7.55433C17.4482 7.51727 17.3495 7.49891 17.2501 7.50031H2.56069L8.28042 1.78058C8.38862 1.67521 8.46249 1.53962 8.49235 1.39157C8.52222 1.24351 8.5067 1.08989 8.44781 0.950809C8.38893 0.811725 8.28943 0.693657 8.16233 0.612057C8.03524 0.530457 7.88647 0.489127 7.7355 0.493475Z"
                fill="#63B15B"
              />
            </svg>
          </span>
          {{ $t("pages.otp_verify.buttons.edit_cell") }}
        </div>

        <h4>
          {{
            $t(
              error
                ? "pages.otp_verify.error.heading"
                : "pages.otp_verify.heading"
            )
          }}
        </h4>
        <p>
          {{
            $t(
              error
                ? "pages.otp_verify.error.sub_heading"
                : "pages.otp_verify.sub_heading"
            )
          }}
        </p>
        <div class="ds_form_block">
          <div class="form-group">
            <div class="w-full flex items-center justify-center optform_block">
              <div class="w-1/4 px-2">
                <input
                  ref="inputZero"
                  :class="{ form_fails: error }"
                  :value="valueZero"
                  type="number"
                  name="inputZero"
                  class="
                    placeholder-current
                    w-14
                    h-12
                    border
                    solid
                    rounded rounded
                    border-color
                    block
                    w-12
                    m-auto
                    text-center
                    outline-none
                  "
                  placeholder=""
                  :min="0"
                  :max="1"
                  pattern="[0-9]*"
                  :maxlength="1"
                  onkeydown="return event.keyCode === 8 ||
event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                  @input="handleOnchangeZero"
                  @keydown="handleOnKeyDown"
                  @focus="currentInput = 0"
                />
              </div>
              <div class="w-1/4 px-2">
                <input
                  ref="inputOne"
                  :class="{ form_fails: error }"
                  :value="valueOne"
                  type="number"
                  name="inputOne"
                  class="
                    placeholder-current
                    w-14
                    h-12
                    border
                    solid
                    rounded rounded
                    border-color
                    block
                    w-12
                    m-auto
                    text-center
                    outline-none
                  "
                  placeholder=""
                  min="0"
                  max="9"
                  pattern="[0-9]*"
                  maxlength="1"
                  onkeydown="return event.keyCode === 8 ||
event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                  @input="handleOnchangeFirst"
                  @keydown="handleOnKeyDown"
                  @focus="currentInput = 1"
                />
              </div>
              <div class="w-1/4 px-2">
                <input
                  ref="inputTwo"
                  :class="{ form_fails: error }"
                  :value="valueTwo"
                  type="number"
                  name="inputTwo"
                  class="
                    placeholder-current
                    w-14
                    h-12
                    border
                    solid
                    rounded rounded
                    border-color
                    block
                    w-12
                    m-auto
                    text-center
                    outline-none
                  "
                  placeholder=""
                  min="0"
                  max="9"
                  pattern="[0-9]*"
                  maxlength="1"
                  onkeydown="return event.keyCode === 8 ||
event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                  @input="handleOnchangeSecond"
                  @keydown="handleOnKeyDown"
                  @focus="currentInput = 2"
                />
              </div>
              <div class="w-1/4 px-2">
                <input
                  ref="inputThree"
                  :class="{ form_fails: error }"
                  :value="valueThree"
                  type="number"
                  maxlength="1"
                  name="inputThree"
                  class="
                    placeholder-current
                    w-14
                    h-12
                    border
                    solid
                    rounded rounded
                    border-color
                    block
                    w-12
                    m-auto
                    text-center
                    outline-none
                  "
                  onkeydown="return event.keyCode === 8 ||
event.keyCode === 46 ? true : !isNaN(Number(event.key))"
                  placeholder=""
                  min="0"
                  max="9"
                  pattern="[0-9]*"
                  @input="handleOnchangeThird($event)"
                  @keydown="handleOnKeyDown"
                  @focus="currentInput = 3"
                />
              </div>
            </div>
          </div>
          <div v-if="otpExpires > 0" class="form-group">
            <label class="time_left">
              {{
                $t("pages.otp_verify.timer", {
                  time: otpExpires,
                })
              }}
            </label>
          </div>
          <div v-else class="action_block">
            <div class="form-group">
              <button
                class="
                  w-full
                  flex
                  items-center
                  justify-center
                  btn_apply
                  rounded-lg
                  text-white
                  btn_kontnormals
                "
                @click="resendOtp"
              >
                {{ $t("pages.otp_verify.buttons.resend_code") }}
              </button>
            </div>
          </div>

         
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isEmpty } from "lodash";
// keyCode constants
const BACKSPACE = 8;
const LEFT_ARROW = 37;
const RIGHT_ARROW = 39;
const DELETE = 46;
export default {
  name: "ConfirmOtp",
  data() {
    return {
      otp: [],
      valueZero: "",
      valueOne: "",
      valueTwo: "",
      valueThree: "",
      currentInput: 0,
      enteredOTP: null,
      error: false,
      timer: 60,
    };
  },
  computed: {
    otpExpires() {
      return this.$store.getters["user/auth"].expires;
    },
  },
  // prettier-ignore
  watch:{
    status: function(val){
      if(this.valueZero.length==1 && this.valueOne.length==1 && this.valueTwo.length==1 && this.valueThree.length==1){
        this.submit();
      }
      return true
    }
  },
  created() {
    if (isEmpty(this.$store.getters["user/auth"].phone)) {
      this.$router.push({ name: "confirmCell" });
    }
  },
  mounted() {
    this.$refs.inputZero.focus();
  },
  methods: {
    validate($event, idx) {
      //keyCodes value
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;

      // only allow number and one dot
      if (keyCode < 48 || keyCode > 57) {
        $event.preventDefault();
      }

      if (idx !== 3) {
        this.$refs[`input-${idx + 1}`].focus();
      }

      if (!_.isEmpty(this.otp[idx]) && this.otp[idx].length >= 1) {
        $event.preventDefault();
      }
    },
    submit() {
      if (
        _.isEmpty(this.valueZero) ||
        _.isEmpty(this.valueOne) ||
        _.isEmpty(this.valueTwo) ||
        _.isEmpty(this.valueThree)
      ) {
        this.error = true;
      } else if (this.error === false) {
        let otp =
          this.valueZero + this.valueOne + this.valueTwo + this.valueThree;

        this.$store.dispatch("user/verifyOtp", otp).then((res) => {
          if (res !== false) {
            if (this.$store.getters["user/registrationState"] || res.new_user) {
              this.$router.push({ name: "acceptContract" });
            } else {
              this.$router.push({ name: "offerSearch" });
            }
            this.error = false;
          } else {
            this.error = true;
          }
        });
      }
    },
    handleOnComplete(value) {
      setTimeout(() => {
        this.submit();
      }, 2000);
    },
    handleOnchangeZero(event) {
      if (this.valueZero.length === 0) {
        this.valueZero = event.target.value;
        this.currentInput = 0;
        this.$refs.inputOne.focus();
      } else if (event.target.value === "") {
        this.valueZero = event.target.value;
      } else {
        this.valueZero = event.target.value.slice(0, 1);
      }
      if (
        this.valueZero != "" &&
        this.valueOne != "" &&
        this.valueTwo != "" &&
        this.valueThree != ""
      ) {
        this.submit();
      }
    },
    handleOnchangeFirst(event) {
      if (this.valueOne.length === 0) {
        this.valueOne = event.target.value;
        this.currentInput = 1;
        this.$refs.inputTwo.focus();
      } else if (event.target.value === "") {
        this.valueOne = event.target.value;
      } else {
        this.valueOne = event.target.value.slice(0, 1);
      }
      if (
        this.valueZero != "" &&
        this.valueOne != "" &&
        this.valueTwo != "" &&
        this.valueThree != ""
      ) {
        this.submit();
      }
    },
    handleOnchangeSecond(event) {
      if (this.valueTwo.length === 0) {
        this.valueTwo = event.target.value;
        this.$refs.inputThree.focus();
        this.currentInput = 2;
      } else if (event.target.value === "") {
        this.valueTwo = event.target.value;
      } else {
        this.valueTwo = event.target.value.slice(0, 1);
      }
      if (
        this.valueZero != "" &&
        this.valueOne != "" &&
        this.valueTwo != "" &&
        this.valueThree != ""
      ) {
        this.submit();
      }
    },
    handleOnchangeThird(event) {
      if (this.valueThree.length === 0) {
        this.valueThree = event.target.value;
        this.currentInput = 3;
      } else if (event.target.value === "") {
        this.valueThree = event.target.value;
      } else {
        this.valueThree = event.target.value.slice(0, 1);
      }
      if (
        this.valueZero != "" &&
        this.valueOne != "" &&
        this.valueTwo != "" &&
        this.valueThree != ""
      ) {
        this.submit();
      }
    },
    handleOnChange(value) {
      if (!this.enteredOTP) {
        this.enteredOTP = parseInt(value, 10);
      }
    },
    focusPrevInput() {
      this.focusOnInput();
    },
    focusOnInput() {
      switch (this.currentInput) {
        case 1:
          this.$refs.inputZero.focus();
          this.currentInput = 0;
          break;
        case 2:
          this.$refs.inputOne.focus();
          this.currentInput = 1;
          break;
        case 3:
          this.$refs.inputTwo.focus();
          this.currentInput = 2;
          break;
      }
    },
    focusNextInput(value) {
      switch (parseInt(this.currentInput, 10)) {
        case 0:
          this.$refs.inputZero.focus();
          break;
        case 1:
          this.$refs.inputOne.focus();
          break;
        case 2:
          this.$refs.inputTwo.focus();
          break;
        case 3:
          this.$refs.inputThree.focus();
          break;
      }
    },
    handleOnKeyDown(event) {
      const { name, value } = event.target;
      if (value.length > 0 && value.length < 2) {
        event.preventDefault();
      }

      switch (event.keyCode) {
        case BACKSPACE:
          event.preventDefault();
          if (name === "inputZero") {
            if (value.length > 0) {
              this.valueZero = "";
              this.error = false;
            }
          } else if (name === "inputOne") {
            if (value.length > 0) {
              this.valueOne = "";
              this.error = false;
            }
          } else if (name === "inputTwo") {
            if (value.length > 0) {
              this.valueTwo = "";
              this.error = false;
            }
          } else if (name === "inputThree") {
            if (value.length > 0) {
              this.valueThree = "";
              this.error = false;
            } else if (value.length > 1) {
              this.valueThree = "";
            }
          }
          // this.changeCodeAtFocus('');
          this.focusPrevInput();
          break;
        case DELETE:
          event.preventDefault();
          // this.changeCodeAtFocus('');
          break;
        case LEFT_ARROW:
          event.preventDefault();
          this.currentInput = this.currentInput - 1;
          this.focusNextInput();
          break;
        case RIGHT_ARROW:
          event.preventDefault();
          this.currentInput = this.currentInput + 1;
          this.focusNextInput();
          break;
        default:
          break;
      }
    },
    resendOtp() {
      this.valueZero = "";
      this.valueOne = "";
      this.valueTwo = "";
      this.valueThree = "";
      this.timer = 60;
      this.error = false;
      this.$store.dispatch("user/resendOtp").then(() => {
        this.$store.commit("app/showNotification", {
          heading: this.$t("pages.otp_verify.resend.heading"),
          buttons: {
            okay: {
              text: "Ok",
              action: () => {
                this.loading = true;
              },
            },
          },
          icon: {
            show: true,
            type: "success",
          },
        });
      });
    },
    
  },
};
</script>

<style scoped>
.bg-green-500 {
  background: #63b15b;
}
.otpmsg-block {
  color: #63b15b;
}
.bg-green-200 {
  background: #e6f7e3;
}

.sign_confirm_block {
  display: block;
  position: relative;
  margin: 0 0 0;
}

.sign_confirm_block h4 {
  font-size: 22px;
  text-align: center;
  width: 100%;
  color: #333333;
  font-weight: bold;
  margin: 0 0 12px;
}

.sign_confirm_block p {
  color: #676666;
  text-align: center;
  font-size: 18px;
  font-weight: 500;
  margin: 0 0 12px;
}

.sign_confirm_block .input-group {
  width: 100%;
  border-radius: 4px;
  padding: 0;
  height: 46px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  border: 1px solid #c6c6d1;
  margin: 0 0 16px;
}

.input-group .input-group-adddon {
  width: 15%;
  border-right: 1px solid #c6c6d1;
  color: #c6c6d1;
  font-weight: 400;
}

.input-group .form-control {
  width: 85%;
  padding-left: 10px;
  color: #c6c6d1;
  border-radius: 8px;
  background: transparent !important;
  outline: none !important;
  box-shadow: none !important;
  border: 0 !important;
  font-size: 14px;
}

.input-group .input-group-adddon .form-control:focus {
  border-color: #63b15b !important;
}
.sign_confirm_block .action_block {
  display: block;
}

.sign_confirm_block .action_block .btn_kontnormals {
  border-color: transparent !important;
  color: #63b15b !important;
  background: transparent !important;
  margin: 15px 0 0;
}
.sign_confirm_block .optform_block {
  padding: 10px 20px 0;
}

.sign_confirm_block .optform_block .form_control {
  text-align: center;
  color: #333333;
  font-weight: 900;
  font-size: 17px;
}

.sign_confirm_block .time_left {
  width: 100%;
  text-align: center;
  display: block;
  color: #c6c6d1;
  font-weight: 500;
  margin: 20px 0 14px;
  font-size: 14px;
}

.sign_confirm_block .time_left.text-green {
  background: #63b15b;
}

.form_fails {
  color: #ee5b64 !important;
  border-color: #ee5b64 !important;
}

/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
@media only screen and (max-width: 767px) {
  .sign_confirm_block h4 {
    font-size: 17px;
  }

  .sign_confirm_block p {
    font-size: 13px;
  }

  .sign_confirm_block .optform_block .form_control {
    font-size: 17px;
  }
}

/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
</style>
